import React from 'react';
import { Box } from '@mui/material';
import { RegionService } from '../../../services/regionService';
import { RegionTypes } from '../../../constants/regionType';
import { buildSiblingRegionUrl } from '../../../helpers/buildSiblingRegionUrlHelper';

const REGION_LABELS = {
	[RegionTypes.Global]: 'Global',
	[RegionTypes.SaudiArabia]: 'Saudi Arabia',
};

export default function LoginRegionLink() {
	const regionService = new RegionService();
	const currentRegion = regionService.currentRegion();
	const siblingUrl = buildSiblingRegionUrl(
		currentRegion,
		process.env.REACT_APP_ADMIN_URL,
		process.env.REACT_APP_ADMIN_URL_SA,
		window.location.pathname,
		window.location.search,
		window.location.hash
	);

	if (!siblingUrl) {
		return null;
	}

	const renderPill = (region) => {
		const isActive = region === currentRegion;
		const pill = (
			<Box
				className={`w-[130px] !text-sm p-1 text-center region-items ${
					isActive ? 'active-region' : 'caption cursor-pointer'
				}`}>
				{REGION_LABELS[region]}
			</Box>
		);

		return isActive ? (
			pill
		) : (
			<a className="no-underline" href={siblingUrl}>
				{pill}
			</a>
		);
	};

	return (
		<Box className="text-center mt-6 mb-2">
			<Box className="flex justify-center items-center">
				<Box className="border rounded-md flex items-center p-1">
					{renderPill(RegionTypes.Global)}
					<Box className="w-1"></Box>
					{renderPill(RegionTypes.SaudiArabia)}
				</Box>
			</Box>
		</Box>
	);
}
